import {BaseFormulaOps} from '@mintdata-wsp/common/controllers/spreadsheet/formula/engine/BaseFormulaOps';
import {FormulaInputEvalOp} from '@mintdata-wsp/common/controllers/spreadsheet/formula/FormulaInputEvalOp';
import {BuildFormulaAST} from '@mintdata-wsp/common/controllers/spreadsheet/formula/operations/buildAST/BuildFormulaAST';

export class FormulaOps
{
    public static BuildFormulaAST:BaseFormulaOps = new BuildFormulaAST();
    public static EvalInput:BaseFormulaOps = new FormulaInputEvalOp();
}
